import { type ApiStorageTransaction } from '@Model';
import { EnumMessageCode, isOk, type Result } from '@synqo/frontend-component-library';

export interface CommitOutcome {
    result: Result<ApiStorageTransaction>;
    /** The texts of the validation errors the booking was refused for. */
    refusal: string | undefined;
}

/** Takes the validation errors out of a refused commit, so the frame does not toast what the fields show. */
// @ai-generated 2026-10-23T17:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function splitRefusal(result: Result<ApiStorageTransaction>): CommitOutcome {
    if (isOk(result)) {
        return { result, refusal: undefined };
    }

    const refused = result.messages.filter((message) => message.code === EnumMessageCode.ValidationError);
    if (refused.length === 0) {
        return { result, refusal: undefined };
    }

    return {
        result: {
            ...result,
            data: undefined,
            messages: result.messages.filter((message) => message.code !== EnumMessageCode.ValidationError),
        },
        refusal: refused.map((message) => message.message).join(' '),
    };
}

/** What a refusal was about: the values of the booking it was made for. */
// @ai-generated 2026-10-23T17:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function bookingStamp(booking: ApiStorageTransaction): string {
    return [
        booking.type,
        booking.occurred_at,
        booking.quantity,
        booking.storage_location.foreign_key,
        booking.material.foreign_key,
        booking.avv.foreign_key,
    ].join('|');
}
